import { render } from "./ListaDeEscapadores.vue?vue&type=template&id=625e2cff&scoped=true&ts=true"
import script from "./ListaDeEscapadores.vue?vue&type=script&lang=ts"
export * from "./ListaDeEscapadores.vue?vue&type=script&lang=ts"

import "./ListaDeEscapadores.vue?vue&type=style&index=0&id=625e2cff&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625e2cff"]])

export default __exports__